document.addEventListener('DOMContentLoaded', () => {
  const hamburgerBtn = document.querySelector('.js-drawer-open-left');
  const navDrawer = document.getElementById('NavDrawer');
  const closeBtn = document.querySelector('.js-drawer-close button'); // Assuming this is your close button

  // Open the drawer and trigger animations
  if (hamburgerBtn && navDrawer) {
    hamburgerBtn.addEventListener('click', () => {
      navDrawer.classList.add('is-open');
    });
  }

  // Close the drawer and reset animations
  if (closeBtn && navDrawer) {
    closeBtn.addEventListener('click', () => {
      navDrawer.classList.remove('is-open');
    });
  }
});